import React from 'react';
import styled from 'styled-components';
import useOnlineStatus from './hooks/useOnlineStatus'

const StatusPanel = styled.div`
  position: fixed;
  z-index: 5000;
  bottom: 15%;
  max-width: 250px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: ${props => props.$isOnline ? 'green' : 'red'};
  transition: opacity 3s ease-in-out;
  opacity: ${props => props.$isOnline === false ? 1 : 0};
  display: ${props => props.$isOnline === false ? 'block' : 'none'};
  color: white;
  border-radius: 999px;
  padding: 1rem 1rem;
`;

function OfflineOnlineIndication() {
  const isOnline = useOnlineStatus();

  return (
    <StatusPanel $isOnline={isOnline} className='subtitle has-text-centered'>
      {isOnline ? "Online" : "Offline"}
    </StatusPanel>
  );
}

export default OfflineOnlineIndication;
